import { createGlobalStyle } from 'styled-components/macro';

import { Theme } from 'common/types/theme.type';

export const StyledEffects = createGlobalStyle<{
  theme: Theme;
}>`
  .grow-small:hover {
    transform: scale(1.01);
  }

  .transition {
    transition: all 0.2s ease-in-out;
  }

  .grow {
    transition: all 0.2s ease-in-out;
  }
  .grow:disabled:hover,
  .grow[disabled]:hover {
    transform: scale(1);
  }

  .grow:hover {
    transform: scale(1.03);
  }

  .grow-small {
    background-color: #fff;
    transition: all 0.2s ease-in-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes highlight {
    0% {
      background-color: #fff9c896;
    }
    66% {
      background-color: #fff9c896;
    }
    100% {
      background-color: white;
    }
  }
`;
